import {
  CurrencySwitcherList
} from "./chunk-46BCKRON.mjs";

// src/CurrencySwitcher.tsx
import { jsx } from "react/jsx-runtime";
var CurrencySwitcher = ({
  onItemClick,
  currencies,
  selectedCurrency
}) => currencies && /* @__PURE__ */ jsx(
  CurrencySwitcherList,
  {
    listItems: currencies.listItems,
    onItemClick,
    selectedCurrency
  },
  "currency-switcher"
);

export {
  CurrencySwitcher
};
